class Deferred {
    constructor () {
        let resolve
        let reject

        /**
         * @type {Promise}
         */
        this.promise = new Promise((res, rej) => {
            resolve = res
            reject = rej
        })

        this._resolve = resolve
        this._reject = reject

        this._resolved = false
    }

    /**
     * @param value {*}
     */
    resolve (value) {
        if (this._resolved) {
            return
        }

        this._resolved = true
        this._resolve(value)
    }

    /**
     * @param ex {Error}
     */
    reject (ex) {
        if (this._resolved) {
            return
        }

        this._resolved = true
        this._reject(ex)
    }

    /**
     * @param onfulfilled
     * @param onrejected
     * @returns {Promise<*>}
     */
    then (onfulfilled, onrejected) {
        return this.promise.then(onfulfilled, onrejected)
    }

    /**
     * @param onrejected
     * @returns {Promise<*>}
     */
    catch (onrejected) {
        return this.promise.catch(onrejected)
    }

    isResolved () {
        return this._resolved;
    }

    swap () {
        let resolve
        let reject

        /**
         * @type {Promise}
         */
        this.promise = new Promise((res, rej) => {
            resolve = res
            reject = rej
        })

        this._resolve = resolve
        this._reject = reject

        this._resolved = false
    }
}

module.exports = function defer () {
    return new Deferred()
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/defer.js